interface FeatureCardType {
  icon: string;
  title: string;
  description: string;
}

const FeatureCard = ({ icon, title, description }: FeatureCardType) => {
  return (
    <div className="rounded-2xl bg-white p-8 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
      <div className="mb-4 text-5xl">{icon}</div>
      <h3 className="mb-4 text-2xl font-bold text-pp-green-primary">{title}</h3>
      <p className="text-base text-pp-text-secondary">{description}</p>
    </div>
  );
};

const FeaturesSection = () => {
  const features: FeatureCardType[] = [
    {
      icon: '💡',
      title: '専門家の知見',
      description:
        '投資家や金融アナリストなど、金融投資の専門家が市況の分析・洞察などの情報を「クリエイター」として発信します。',
    },
    {
      icon: '🤝',
      title: 'コミュニティ',
      description:
        'お金や投資の話題をきっかけに、仲間を作って情報交換や交流を深めることができます。(匿名制)',
    },
    {
      icon: '📊',
      title: '金融情報',
      description:
        '株、為替、商品先物、仮想通貨など金融マーケットの情報やPostPrime会員のチャート投票による投資家心理の情報もリアルタイムでキャッチできます。',
    },
  ];

  return (
    <section id="features" className="w-full bg-pp-bg-secondary px-6 py-20">
      <div className="mx-auto max-w-6xl">
        <h2 className="mb-4 text-center text-3xl font-bold text-pp-text-primary md:text-4xl">
          PostPrimeの特徴
        </h2>
        <p className="mx-auto mb-16 max-w-4xl text-center text-base text-pp-text-secondary md:text-lg">
          PostPrimeは、投資に特化したソーシャルメディアプラットフォームです。「毎日トレーディングしている個人投資家」と「これから始めたい人」をつなぎ、質の高い情報交換を実現します。
        </p>

        <div className="grid gap-8 md:grid-cols-3">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
